import { render, staticRenderFns } from "./TrainingCourse.vue?vue&type=template&id=739ef4bf&"
import script from "./TrainingCourse.vue?vue&type=script&lang=ts&"
export * from "./TrainingCourse.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports